export function gainFromScore(previous: number, next: number): number {
  if (!Number.isFinite(previous) || !Number.isFinite(next) || next <= previous) return 0;
  return next - previous;
}
